import { featuresStatuses, getBrandConfig } from '../../../config/brands'
import { routes } from '../../routes'

export const getStartPage = () => {
  const { brandConfig } = getBrandConfig()
  const defaultStartPage = featuresStatuses.isDashboardPageEnabled ? routes.ROUTES_DASHBOARD.root : routes.ROUTES_OFFERS.offers

  return brandConfig.startPage || defaultStartPage
}
